import React from 'react';
import cn from 'classnames';
import { func, string, bool, number } from 'prop-types';
import { t } from 'i18next';

import { ANALYTICS_CLASSES } from '~constants/analytics';
import { FIELDS } from '~screens/Dashboard/screens/Home/screens/Checkout/constants';
import PaymentButton from '~screens/Dashboard/screens/Home/screens/Checkout/components/PaymentMethodContainer/components/PaymentButton';
import { PAYMENT_CARD_ICONS } from '~constants/paymentMethods';

import styles from './styles.module.scss';

function CardInformation({
  id,
  cardId,
  cardNumber,
  kind,
  iconClassName,
  selectedCardId,
  onSelectCardPayment,
  onAddCard,
  isAddCardButton,
  cardOnlinePaymentMethod,
  setFieldValue,
  loading,
  ingenicoCreateCard,
  className,
  editingCards,
  openDeleteCreditCardModal,
  closeModal,
  disabled,
  changingActive
}) {
  function handleSelectCardPayment() {
    if (isAddCardButton) {
      onAddCard();
    } else {
      closeModal?.();
      if (setFieldValue) {
        setFieldValue(FIELDS.cardCode, '');
      }
      onSelectCardPayment({
        cardId,
        paymentMethod: cardOnlinePaymentMethod,
        kind,
        cardNumber,
        changingActive
      });
    }
  }

  const handleOpenModalDeleteCard = () => openDeleteCreditCardModal({ cardId, kind, cardNumber });
  return (
    <PaymentButton
      id={id || kind}
      name={cardNumber}
      // eslint-disable-next-line react/jsx-no-bind
      onClick={handleSelectCardPayment}
      className={cn(ANALYTICS_CLASSES.checkout.cardPayment, className, {
        [styles.noEvents]: loading
      })}
      selected={(selectedCardId && selectedCardId === cardId) || ingenicoCreateCard}
      ariaLabel={t(`CheckoutPaymentMethodList:${name}`)}
      iconClassName={iconClassName}
      iconStyle={styles.cardIcon}
      disabled={disabled || loading}
      editingCards={editingCards}
      onDeleteCard={handleOpenModalDeleteCard}
      isACreditCard
      changingActive={changingActive}
    />
  );
}

CardInformation.defaultProps = {
  iconClassName: PAYMENT_CARD_ICONS.Unknown,
  loading: false
};

CardInformation.propTypes = {
  cardOnlinePaymentMethod: string.isRequired,
  openDeleteCreditCardModal: func.isRequired,
  cardId: number,
  cardNumber: string,
  changingActive: bool,
  className: string,
  closeModal: func,
  disabled: bool,
  editingCards: bool,
  iconClassName: string,
  id: string,
  ingenicoCreateCard: bool,
  isAddCardButton: bool,
  kind: string,
  loading: bool,
  selectedCardId: number,
  setFieldValue: func,
  onAddCard: func,
  onSelectCardPayment: func
};

export default CardInformation;
